(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'product-recommendations'
  var productRecommendationsSection = document.querySelector(".product-recommendations");
  if (productRecommendationsSection === null) { return; }
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", productRecommendationsSection.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      var fresh = container.querySelector(".product-recommendations");
      if (!fresh) return;
      /* P2: MERGE, do not replace. The first-party co-purchase cards were
         rendered with the page; the API cards top the grid up to the
         limit, skipping any product already shown and the one on screen. */
      var limit = parseInt(productRecommendationsSection.getAttribute('data-hl-limit'), 10) || 4;
      var ownGrid = productRecommendationsSection.querySelector('[data-hl-recs-grid]');
      var apiBlock = fresh.querySelector('[data-hl-recs-api]');
      /* Never repeat the product on screen, a first-party card, or anything
         "The Collection" carousel above already shows - the two bands must
         not be the same six coats twice. */
      var seen = {};
      seen[productRecommendationsSection.getAttribute('data-hl-product-id')] = true;
      document.querySelectorAll('.hl-colour-edit .product-block[data-product-id]').forEach(function (b) { seen[b.getAttribute('data-product-id')] = true; });
      if (!ownGrid) {
        /* nothing first-party: the API block is the whole section, trimmed
           to the limit with the exclusions applied */
        if (!apiBlock) return;
        var kept = 0;
        apiBlock.querySelectorAll('.hl-recs__slot').forEach(function (slot) {
          var pb = slot.querySelector('.product-block[data-product-id]');
          var id = pb && pb.getAttribute('data-product-id');
          if (!id || seen[id] || kept >= limit) { slot.parentNode.removeChild(slot); return; }
          seen[id] = true; kept += 1;
        });
        if (kept === 0) return;
        productRecommendationsSection.innerHTML = fresh.innerHTML;
      } else if (apiBlock) {
        ownGrid.querySelectorAll('.product-block[data-product-id]').forEach(function (b) { seen[b.getAttribute('data-product-id')] = true; });
        var have = ownGrid.querySelectorAll('.hl-recs__slot').length;
        apiBlock.querySelectorAll('.hl-recs__slot').forEach(function (slot) {
          if (have >= limit) return;
          var pb = slot.querySelector('.product-block[data-product-id]');
          var id = pb && pb.getAttribute('data-product-id');
          if (!id || seen[id]) return;
          seen[id] = true;
          ownGrid.appendChild(slot);
          have += 1;
        });
      }
      theme.ProductBlockManager.loadImages(productRecommendationsSection);
      theme.initAnimateOnScroll();
    }
  };
  request.send();
};
// fetch when section reloads in editor
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].product-recommendations')) {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();
})();
